import { DivisaReadingDtoProps } from "./DTOs/DivisaReadingDto"

export const divisaAdapter = (
  divisa: DivisaReadingDtoProps
): DivisaReadingDtoProps => ({
  id: divisa.id,
  abreviatura: divisa.abreviatura,
  descripcion: divisa.descripcion,
  simbolo: divisa.simbolo,
})
